import React from 'react';
import styles from './Dashboard.module.css';
import emptyData from '../../assets/images/emptyData.svg';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import UserIcon from '../../assets/images/dashboard_user_image.png';
import DeviceIcon from '../../assets/images/dashboard_device_image.png';

const Card = ({
    headerText,
    navigationRoute,
    redirectCallback,
    activeCount,
    totalCount,
}) => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <div className={styles.card}>
            <div className='flex justify-content-between align-items-end'>
                <div className={styles.card_header_left}>{headerText}</div>
                <div
                    className={styles.card_header_right}
                    onClick={redirectCallback}
                >
                    {`+ Add ` + headerText}
                </div>
            </div>
            <div className='flex justify-content-between'>
                {totalCount > 0 ? (
                    <div
                        className={styles.total_count_box}
                        onClick={() => handleNavigation(navigationRoute)}
                    >
                        <div className='ml-2 mt-1'>
                            <img
                                style={{ height: '100%' }}
                                src={
                                    headerText === 'Users'
                                        ? UserIcon
                                        : DeviceIcon
                                }
                            />
                        </div>
                        <div className='ml-6'>
                            <div className={styles.count}>{totalCount}</div>
                            <div className={styles.count_lable}>
                                Total {headerText}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={styles.no_data_box}>
                        <div className={styles.no_data_img}>
                            <img src={emptyData} />
                        </div>
                        <div className={styles.no_data_title}>
                            {f({ id: 'AI_EDU_NO_DATA_TO_SHOW' })}
                        </div>
                        <div className={styles.no_data_subtitle}>
                            Start adding {headerText}
                        </div>
                    </div>
                )}
                {/* <div className={styles.active_count_box}>
                    <div className={styles.count_avatar}></div>
                    <div className="ml-4 mt-3">
                        <div className={styles.count}>{activeCount}</div>
                        <div className={styles.count_lable}>Active Counts</div>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default Card;
